import api from 'api/axiosInstance';
import appI18nInstance from 'i18n';
import { stringify } from 'query-string';
import type { Currency } from 'types/global.types';
import type { IPaginationRequest, Paging } from 'types/pagination.types';
import type { Transaction } from 'types/transactions.types';

const service = '/v1/transactions';

type Params = IPaginationRequest & {
  accountNumbers?: string;
  toClassify?: 'yes' | 'no';
  deleted?: 'yes' | 'no';
  text?: any;
  currency?: Currency;
  statuses?: string;
  transactionTypes?: string;
};

type Response = {
  data: Transaction[];
  paging: Paging;
};

// TODO: This is a work around. Discuss it with the team: either modify the filter
// from the Backend, or restructure filters configuration into custom configuration for each world
const toClassifyMapper = {
  yes: 'true',
  no: 'false',
};

const hiddenTransactionsFilterMapper = {
  yes: 'true',
  no: 'false',
};

const getTransactions = (params: Params): Promise<Response> =>
  api.get(
    `${service}?${stringify(
      {
        lang: appI18nInstance.language,
        ...params,
        expense_version: 3,
        toClassify:
          toClassifyMapper[params.toClassify as keyof typeof toClassifyMapper],
        deleted:
          hiddenTransactionsFilterMapper[
            params.deleted as keyof typeof hiddenTransactionsFilterMapper
          ],
      },
      {
        skipEmptyString: true,
        arrayFormat: 'comma',
      },
    )}`,
  );

export default getTransactions;
